import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AiInput } from '@/shared/ui';

type BlockPointsFieldProps = {
  maxPoints: number | null;
  possiblePoints: number[] | null;
  /** Справочник, которым оценивается блок: вместо баллов либо, у совмещённой шкалы, вместе с ними */
  possibleValues: string[] | null;
  isProcessing: boolean;
};

/**
 * Чем оценивается листовой блок: баллами (максимальный и перечень возможных), справочником значений
 * либо и тем, и другим сразу — тогда шкала читается обеими подписями подряд, баллы перед значениями.
 * Всё это определяет сервер по правилам блока, поэтому поле недоступно для ввода; размерность,
 * в которой читается балл, стоит отдельным полем — её пользователь правит сам.
 */
export const BlockPointsField: FC<BlockPointsFieldProps> = ({
  maxPoints,
  possiblePoints,
  possibleValues,
  isProcessing,
}) => {
  const { t } = useTranslation('expertReport');

  const getPointsText = () => {
    if (maxPoints === null) return '';
    return !possiblePoints?.length
      ? t('pointsMaxOnly', { max: maxPoints })
      : t('pointsValue', { max: maxPoints, possible: possiblePoints.join(', ') });
  };

  const getValue = () => {
    const values = possibleValues?.length ? t('pointsPossibleValues', { values: possibleValues.join(', ') }) : '';
    return [getPointsText(), values].filter(Boolean).join(' ');
  };

  return (
    <AiInput
      label={t('points')}
      value={getValue()}
      placeholder={t('pointsNotResolved')}
      disabled
      isProcessing={isProcessing}
    />
  );
};
